import React, { useState } from "react";
import Header from "../../commons/header/header";
import Footer from "../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Carousel styles
import "./placement.css"; // Ensure you have a CSS file for styling
import image3 from "../../../assests/images/agri-bg.jpg";

const Placement = () => {
  const [selectedTab, setSelectedTab] = useState("vision-mission");

  // Table data
  const placementData = [
    {
      id: 1,
      academicYear: "2023-2024",
      totalOutgoing: 160,
      placements: 116,
      higherEducation: "NIL",
      percentage: "72.5%",
    },
    {
      id: 2,
      academicYear: "2022-2023",
      totalOutgoing: 146,
      placements: 103,
      higherEducation: "01",
      percentage: "71.23%",
    },
    {
      id: 3,
      academicYear: "2021-2022",
      totalOutgoing: 164,
      placements: 115,
      higherEducation: "03",
      percentage: "71.95%",
    },
    {
      id: 4,
      academicYear: "2020-2021",
      totalOutgoing: 143,
      placements: 102,
      higherEducation: "01",
      percentage: "72.02%",
    },
    {
      id: 5,
      academicYear: "2019-2020",
      totalOutgoing: 103,
      placements: 72,
      higherEducation: "02",
      percentage: "71.84%",
    },
  ];

  return (
    <>
      <Header />
      <div className="image-section">
        <img src={image3} alt="Gallery" className="department-image" />
        <div className="overlay-text">Placement</div>
      </div>
      <div className="placement-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1}
            sx={{
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={
                selectedTab === "vision-mission" ? "contained" : "outlined"
              }
              onClick={() => setSelectedTab("vision-mission")}
              style={{
                width: "100%",
                color: selectedTab === "vision-mission" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "vision-mission" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Vision & Mission
            </Button>
            <Button
              variant={
                selectedTab === "placed-students" ? "contained" : "outlined"
              }
              onClick={() => setSelectedTab("placed-students")}
              style={{
                width: "100%",
                color: selectedTab === "placed-students" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "placed-students" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Placed Students
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            {selectedTab === "vision-mission" && (
              <div className="content-section">
                <h3>Vision</h3>
                <p>
                  To empower students with the necessary skills, knowledge, and
                  opportunities to achieve meaningful careers and become
                  globally competent professionals, while bridging the gap
                  between academic learning and industry expectations.
                </p>
                <h3>Mission</h3>
                <ul>
                  <li>
                    To enhance students' employability through comprehensive
                    training in soft skills, technical skills, and industry
                    readiness.
                  </li>
                  <li>
                    To guide students in career planning, higher education, and
                    entrepreneurship.
                  </li>
                  <li>
                    To continuously engage with alumni and industry experts to
                    align training with current trends and demands.
                  </li>
                </ul>
              </div>
            )}
            {selectedTab === "placed-students" && (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        S.No.
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Academic Year
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Total No. of Outgoing Students
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        No. of Students Progressed to Placements
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        No. of Students Progressed to Higher Education
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Percentage of Students Progressed
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {placementData.map((data, index) => (
                      <TableRow
                        key={data.id}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "white" : "#f1f8e9",
                        }}
                      >
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.id}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.academicYear}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.totalOutgoing}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.placements}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.higherEducation}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.percentage}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default Placement;
